import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const AdminPermission = () => {
  const { search } = useLocation();
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [action, setAction] = useState([]); // Organization list
  const [permissionType, setPermissionType] = useState([]); // Permission type list
  const [action2, setAction2] = useState(null); // Selected permission type
  const [action1, setAction1] = useState([]); // Permission checkboxes
  const [select, setSelect] = useState(null); // Selected organization

  const jwtToken = localStorage.getItem("jwt_token");

  const paramIdSeprator = (param) => param.split("=")[1];
  const paramIdSeprator2 = (param) => param.split("=")[2];
  const id = paramIdSeprator(search);
  const people_id = paramIdSeprator2(search);
  const col_id = id.split("&")[0];

  useEffect(() => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_API_URL}/organisations`;
      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      const orgList = data.data.organizations.map((org) => ({
        ...org,
        value: org.id,
        label: org.name,
      }));
      setAction(orgList);
      await fetchPermissionTypes(orgList);
    };

    fetchData();
  }, []);

  const fetchPermissionTypes = async (orgList) => {
    const url = `${process.env.REACT_APP_API_URL}/people-permission`;
    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    const perms = data.data.map((perm) => ({
      ...perm,
      value: perm.id,
      label: perm.type,
    }));
    setPermissionType(perms);
    update(orgList, perms);
  };

  const onChangePermission = (e) => {
    setAction2(e);

    if (e?.permissions_list?.length > 0) {
      const peoplePerms = e.permissions_list.map((perm, index) => {
        let shouldBeChecked = true;

        if (
          e.type === "External Instructor" &&
          (index === 0 || index === e.permissions_list.length - 1)
        ) {
          shouldBeChecked = false;
        }

        if (e.type === "Employee" && index === e.permissions_list.length - 1) {
          shouldBeChecked = false;
        }

        return { one: perm, checked: shouldBeChecked };
      });

      setAction1(peoplePerms);
    }
  };


  const onCheckboxHandler = (e, index) => {
    const updated = [...action1];
    updated[index].checked = e.target.checked;
    setAction1(updated);
  };

  const add = (checkedIndexes) => {
    const url = `${process.env.REACT_APP_API_URL}/role-data`;

    const body = {
      organization_id: select ? select.id : 0,
      checkbox: checkedIndexes.length > 0 ? checkedIndexes.join(",") : "",
      people_id: +col_id,
      type: action2?.type,
    };

    fetch(url, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          toast.error(data.error);
        } else {
          toast.success("Data Added");
          window.history.back();
        }
      });
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();

    const checkedIndexes = action1
      .map((item, index) => (item.checked ? index : null))
      .filter((index) => index !== null);

    if (people_id && col_id) {
      const body = {
        checkbox: checkedIndexes.join(","),
        id: +people_id,
        people_id: +col_id,
        organisation_id: select ? select.id : 0,
        type: action2?.type,
      };

      fetch(`${process.env.REACT_APP_API_URL}/update-role-data`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.error) {
            toast.error(data.error);
          } else {
            toast.success("Permissions updated!");
          }
        });
    } else {
      add(checkedIndexes);
    }
  };

  const update = async (orgList, permissions) => {
    const url = `${process.env.REACT_APP_API_URL}/update-role-data/${people_id}/${col_id}`;
    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();

    const matchedOrg = orgList.find(
      (org) => org.id === data.data.organisation_id
    );
    setSelect(matchedOrg);

    const matchedType = permissions.find(
      (perm) => perm.type === data.data.type
    );
    setAction2(matchedType);

    const checkedIndexes = data.data.checkbox
      ? data.data.checkbox.split(",").map(Number)
      : [];

    onChangePermission(matchedType);

    const updatedPeoplePermissions = matchedType.permissions_list.map(
      (perm, index) => ({
        one: perm,
        checked: checkedIndexes.includes(index),
      })
    );
    setAction1(updatedPeoplePermissions);
  };


  return (
    <div className="mt-2">
      <h6>Permission Control</h6>
      <form onSubmit={onSubmitHandler}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Organisation:</label>
            <Select
              className="basic-single"
              classNamePrefix="select"
              value={select}
              options={action}
              onChange={(e) => setSelect(e)}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Account Type:</label>
            <Select
              className="basic-single"
              classNamePrefix="select"
              value={action2}
              options={permissionType}
              onChange={(e) => onChangePermission(e)}
            />
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-md-6">
            <h6>People Permissions</h6>
            {action1.length === 0 ? (
              <p>No people permissions for this role.</p>
            ) : (
              <ul className="list-unstyled">
                {action1.map((perm, index) => {
                  const formatted = perm.one
                    .split("_")
                    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                    .join(" ");

                  return (
                    <li key={index} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`perm-${index}`}
                        checked={perm.checked}
                        onChange={(e) => onCheckboxHandler(e, index)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`perm-${index}`}
                      >
                        {formatted}
                      </label>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        </div>

        <button type="submit" className="btn bg_color mt-3">
          {people_id ? "Update" : "Add"}
        </button>
      </form>
    </div>
  );
};

export default AdminPermission;
